import React, { useState } from 'react';
import merkleData from '../merkleData.json';
import { phaseList } from '../phaseList';
import '../App.css';

export default function WalletChecker() {
  const [inputAddress, setInputAddress] = useState('');
  const [checkedAddress, setCheckedAddress] = useState('');

  const handleCheck = () => {
    if (!/^0x[a-fA-F0-9]{40}$/.test(inputAddress.trim())) {
      alert('wallet address format is wrong');
      return;
    }
    setCheckedAddress(inputAddress.trim());
  };

  return (
    <div className="container">
      <h2 className="title">The Void Zone Allowlist Checker</h2>

      <input
        type="text"
        className="input"
        placeholder="0x... (EVM Wallet Address)"
        value={inputAddress}
        onChange={(e) => setInputAddress(e.target.value)}
      />

      <button className="button" onClick={handleCheck}>
        Check
      </button>

      {checkedAddress && (
        <div className="result-box">
          
          {phaseList.map((phase) => {
            const proofMap = merkleData?.[phase.id]?.proofs || {};
            const eligible =
              phase.name === 'Public'
                ? true
                : Object.keys(proofMap).some(
                    (key) => key.toLowerCase() === checkedAddress.toLowerCase()
                  );

            return (
              <div
                key={phase.id}
                className={`result-row ${eligible ? 'eligible' : 'not-eligible'}`}
              >
                <span>{phase.name}</span>
                <span>{eligible ? '✅ Eligible' : '❌ Not Eligible'}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
